import { render, staticRenderFns } from "./ProposalFilter.vue?vue&type=template&id=058622b5&"
import script from "./ProposalFilter.vue?vue&type=script&lang=js&"
export * from "./ProposalFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports